import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod/v4";

export const getPackingSlipPredictions = {
  name: "getPackingSlipPredictions" as const,
  input: z.object({
    currentGroupId: z.string(),
  }),
  output: z.object({
    predictions: z.array(FulfillmentGroupDataSchema),
  }),
};
